"use client";

import { c as _c } from "react/compiler-runtime";
import React, { Suspense } from "react";
import MyStreamWaveContent, { type MyStreamWaveProps } from "./MyStreamWaveContent";
const MyStreamWave: React.FC<MyStreamWaveProps> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Suspense fallback={null}><MyStreamWaveContent {...props} /></Suspense>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default React.memo(MyStreamWave);